<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
import { passwordRule } from '../validation/rules'
import PasswordField from './components/PasswordField'

Vue.use(Vuelidate)

export default {
    components: {
        'password-field': PasswordField
    },
    data() {
        return {
            current: '',
            password: '',
            confirm: ''
        }
    },
    validations: {
        current: {
            required
        },
        password: {
            required,
            passwordRule,
            minLength: minLength(8),
            maxLength: maxLength(20),
        },
        confirm: {
            required,
            sameAs: sameAs('password'),
            passwordRule
        }
    },
    computed: {
        isDisabled: function(){
            return this.$v.$invalid || (this.current === '' || this.password === '' || this.confirm === '');
        }
    },
    methods: {
        submit: function(){
            const form = this.$refs.updatePasswordForm;

            this.$v.$touch();
            if (this.$v.$invalid) {
                alert('バリデーションエラー');
                return false;
            } else {
                form.submit();
            }
        }
    }
}
</script>
